<template>
  <div class="card">
    <div
      :class="
        cardData.color == 'none'
          ? ''
          : cardData.color == 'green'
          ? 'border-right-green'
          : cardData.color == 'yellow'
          ? 'border-right-yellow'
          : cardData.color == 'red'
          ? 'border-right-red'
          : 'border-right-purple'
      "
      style="
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin-left: -5px;
        min-height: 40px;
        border-radius: 4px;
      "
    >
      &nbsp;
    </div>
    <div
      class="d-flex flex-column card-body text-start"
      style="
        justify-content: center;
        padding-left: 20px !important;
        padding-right: 20px !important;
      "
    >
      <div>
        <span v-if="title" class="card-title font-gbook fsize-14">{{
          title
        }}</span>
        <span
          class="fsize-12"
          :class="
            cardData.percentage > 0
              ? 'card-percentage'
              : 'card-percentage-minus'
          "
          v-if="cardData.percentage"
          >&nbsp;
          <i class="fas fa-caret-up" v-if="cardData.percentage > 0"></i>
          <i class="fas fa-caret-down" v-else></i>
          &nbsp;{{ cardData.percentage }}%</span
        >
      </div>
      <div class="d-flex">
        <div class="fsize-16" :class="cardData.class" :style="cardData.style">
          <label
            v-if="typeof cardData.value == 'string'"
            class="card-text"
            :style="{ color: cardData.color_text }"
            >{{ cardData.value }}</label
          >
          <label
            v-if="typeof cardData.value == 'number'"
            class="card-text"
            :style="{ color: cardData.color_text }"
            >{{ cardData.value.toLocaleString().replaceAll(",", ".") }}</label
          >
        </div>
        <div v-if="cardData.url" class="col-2 text-center">
          <label class="card-text fsize-20">
            <i class="fas fa-chevron-right"></i>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardCard",
  props: ["title", "cardData"],
  data() {
    return {
      print: "",
    };
  },
  methods: {
    returnString(data) {
      this.print = data + "string";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card-title {
  color: #8d94a6;
}
.card-text {
  font-weight: bold;
  color: #5e50a1;
}
.card-percentage {
  color: #30cb9d;
}
.card-percentage-minus {
  color: #ff434f;
}
.card {
  height: 75px !important;
}
.border-right-green {
  border-right: 0.5rem solid #30cb9d !important;
}
.border-right-yellow {
  border-right: 0.5rem solid #ffb200 !important;
}
.border-right-red {
  border-right: 0.5rem solid #ed413f !important;
}

.border-right-purple {
  border-right: 0.5rem solid #5e50a1 !important;
}

.card-body {
  padding: 0.5rem 1rem !important;
}
</style>
